import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";

function ViewNews() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [deleted, setDeleted] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.React_APP_BACKEND_URL}/api/getanews?id=${id}`, {
        headers: { Authorization: `Bearer ${Cookies.get("token")}` },
      })
      .then((res) => setNews(res.data.news))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [id]);

  const deleteNews = () => {
    axios
      .delete(`${process.env.React_APP_BACKEND_URL}/api/admin/deletenews?id=${id}`, {
        headers: { Authorization: `Bearer ${Cookies.get("admintoken")}` },
      })
      .then(() => setDeleted(true))
      .catch(() => setError(true));
  };

  if (deleted) return <Navigate to="/home" />;

  return (
    <Box component="main" dir="rtl" sx={{ minHeight: "calc(100vh - 72px)", py: { xs: 3, md: 6 }, px: 2, fontFamily: "Assistant", background: "linear-gradient(180deg, #F5FAFD 0%, #FFFFFF 65%)" }}>
      <Box sx={{ width: "100%", maxWidth: 760, mx: "auto" }}>
        <Button onClick={() => navigate(-1)} startIcon={<ArrowBackRoundedIcon />} sx={{ mb: 2, color: "#45677F", fontFamily: "Assistant", fontWeight: 700, "& .MuiButton-startIcon": { ml: 0.6, mr: 0 } }}>
          חזרה
        </Button>

        <Box sx={{ bgcolor: "#FFFFFF", border: "1px solid #E2ECF3", borderRadius: { xs: "20px", md: "26px" }, boxShadow: "0 16px 44px rgba(25, 73, 105, .09)", overflow: "hidden" }}>
          <Box sx={{ minHeight: 82, px: { xs: 2.2, sm: 3.5 }, display: "flex", alignItems: "center", gap: 1.2, bgcolor: "#F8FBFD", borderBottom: "1px solid #E8F0F5" }}>
            <Box sx={{ width: { xs: 76, sm: 86 }, height: { xs: 76, sm: 86 }, flex: "0 0 auto", borderRadius: "50%", overflow: "hidden", boxShadow: "0 7px 20px rgba(23,63,93,.14)" }}>
              <Box component="img" src="/chat_logo.png" alt="Bidit" sx={{ display: "block", width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }} />
            </Box>
            <Box>
              <Typography sx={{ color: "#173F5D", fontWeight: 800, fontSize: 17 }}>הודעה מ-Bidit</Typography>
              <Typography sx={{ color: "#7890A1", fontSize: 13 }}>כל הפרטים במקום אחד</Typography>
            </Box>
          </Box>

          <Box sx={{ p: { xs: 2.4, sm: 4, md: 5 } }}>
            {loading && <Box sx={{ minHeight: 180, display: "grid", placeItems: "center" }}><CircularProgress size={30} sx={{ color: "#1686C7" }} /></Box>}

            {error && !loading && (
              <Box sx={{ py: 7, textAlign: "center" }}>
                <Typography sx={{ color: "#173F5D", fontWeight: 800, fontSize: 19 }}>לא הצלחנו לטעון את ההודעה</Typography>
                <Typography sx={{ mt: 0.7, color: "#6E8798" }}>אפשר לחזור ולנסות שוב בעוד רגע.</Typography>
              </Box>
            )}

            {news && !loading && (
              <>
                <Typography component="h1" sx={{ color: "#173F5D", fontWeight: 800, fontSize: { xs: 24, sm: 30 }, lineHeight: 1.3 }}>{news.title}</Typography>
                {news.date && <Typography sx={{ mt: 1, color: "#8195A4", fontSize: 14 }}>{news.date}</Typography>}
                <Box sx={{ width: 44, height: 3, mt: 2.2, mb: 2.5, borderRadius: 3, bgcolor: "#F2A325" }} />
                <Typography component="div" sx={{ color: "#405D71", fontSize: { xs: 16, sm: 17 }, lineHeight: 1.8, whiteSpace: "pre-line" }}>{news.des}</Typography>

                {Cookies.get("adminId") && (
                  <Button variant="outlined" color="error" startIcon={<DeleteOutlineRoundedIcon />} onClick={deleteNews} sx={{ mt: 4, fontFamily: "Assistant", fontWeight: 700, borderRadius: "12px" }}>
                    מחיקת ההודעה
                  </Button>
                )}
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default ViewNews;
